import React, { createContext, useState, useContext, useEffect, ReactNode } from 'react';
import { firebaseAuthService, AdminUser } from '../services/FirebaseAuthService';

interface AdminAuthContextType {
  admin: AdminUser | null;
  isAuthenticated: boolean;
  login: (email: string, password: string) => Promise<boolean>;
  logout: () => void;
  loading: boolean;
}

const AdminAuthContext = createContext<AdminAuthContextType | undefined>(undefined);

export const useAdminAuth = () => {
  const context = useContext(AdminAuthContext);
  if (context === undefined) {
    throw new Error('useAdminAuth must be used within an AdminAuthProvider');
  }
  return context;
};

interface AdminAuthProviderProps {
  children: ReactNode;
}

export const AdminAuthProvider: React.FC<AdminAuthProviderProps> = ({ children }) => {
  const [admin, setAdmin] = useState<AdminUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simple check for persistent login
    const savedAdmin = localStorage.getItem('upm_admin');
    if (savedAdmin) {
      try {
        const adminData = JSON.parse(savedAdmin);
        setAdmin(adminData);
      } catch (error) {
        localStorage.removeItem('upm_admin');
      }
    }
    setLoading(false);
  }, []);

  const login = async (email: string, password: string): Promise<boolean> => {
    try {
      setLoading(true);
      
      // Simple check for the specific admin credentials
      if (email === 'admin@upmtraders.com' && password === 'Sajee2911@Nihar###@@@###$$$!!!') {
        const adminUser: AdminUser = {
          uid: 'admin-user',
          email: 'admin@upmtraders.com',
          displayName: 'UPM Traders Admin',
          role: 'superadmin',
          createdAt: new Date().toISOString(),
          lastLogin: new Date().toISOString(),
          isActive: true
        };
        setAdmin(adminUser);
        
        // Save to localStorage for persistence
        localStorage.setItem('upm_admin', JSON.stringify(adminUser));
        
        return true;
      }
      
      return false;
    } catch (error) {
      console.error('Login error:', error);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try {
      localStorage.removeItem('upm_admin');
      setAdmin(null);
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const value = {
    admin,
    isAuthenticated: !!admin,
    login,
    logout,
    loading
  };

  return (
    <AdminAuthContext.Provider value={value}>
      {children}
    </AdminAuthContext.Provider>
  );
};